import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

import { styled, useTheme } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ToolTip from 'components/Common/ToolTip'
import RiskScoreTooltipContent from './RiskScoreTooltipContent'
// import RiskClassTooltipContent from './RiskClassTooltipContent'
import { MOCK_DATA_BUSINESS } from './constants'
import SectionTitle from 'components/Common/SectionTitle'
import { Divider, Link } from '@mui/material'
import BusinessCreditProgress from 'components/Common/BusinessCreditProgress/BusinessCreditProgress'
import { store } from 'reduxStore'
import api from 'api'
import { useState } from 'react'
import moment from 'moment'
import BusinessCreditChart from 'components/Common/BusinessCreditProgress/BusinessCreditChart'
import BusinessCreditTooltip from './BusinessCreditTooltip'
import RiskClassTooltipContent from './RiskClassTooltipContent'
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots'
import BusinessCreditProgressDisabled from 'components/Common/BusinessCreditProgress/BusinessCreditProgressDisabled'

const ProfileCardContainer = styled(Box)(({ theme }) => ({
  height: '100%',
  display: 'inline',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'left',
}))

const BusinessSummary = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'baseline',
  justifyContent: 'space-between',
}))

const ProfileCompletedProgress = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
}))

const ClaimedBusinessProfile = props => {
  const theme = useTheme()
  const navigate = useNavigate()
  const { businessData } = props
  const { business_info } = useSelector(state => state.apiResponseReducers.dashboardInfo)

  // const [businessCreditLastDate, setBusinessCreditLastDate] = useState()
  const [businessCreditScore, setBusinessCreditScore] = useState()
  const [businessCreditScoreExpiry, setBusinessCreditScoreExpiry] = useState()
  const [businessCreditScoreSate, setBusinessCreditScoreState] = useState()
  const [scoreStatus, setScoreStatus] = useState()
  const [loading, setLoading] = useState(false)

  const user = store.getState().userReducer.user
  const { credit_risk_score_max } = businessData

  let creditClassData = business_info?.claimed_business_details?.crc || MOCK_DATA_BUSINESS.credit_class
  let colors =
    creditClassData >= 4
      ? theme.palette.color.negative
      : creditClassData <= 2
      ? theme.palette.color.aqua110
      : theme.palette.color.blueLight

  // const goToDashboard = () => {
  //   navigate('/find')
  // }

  useEffect(() => {
    getCreditScoreOnLoad()
  })

  const goToWelcome = () => {
    navigate('/welcome')
  }

  const getCreditScoreOnLoad = async () => {
    const data = await api.getBusinessData(business_info.claimed_business_details.ext_id, false)
    // if (data?.bizCreditLastAPIDate) setBusinessCreditLastDate(data.bizCreditLastAPIDate)
    if (data?.bizCreditScore) setBusinessCreditScore(parseInt(data.bizCreditScore))
    if (data?.bizCreditScoreExpiryDate) setBusinessCreditScoreExpiry(data.bizCreditScoreExpiryDate)
    if (data?.bizCreditScoreState) setBusinessCreditScoreState(data.bizCreditScoreState)
    if (data?.bizCreditScoreStatus) setScoreStatus(data.bizCreditScoreStatus)
    setLoading(false)
  }

  const getCreditScore = async () => {
    const data = await api.getBusinessData(business_info.claimed_business_details.ext_id, true)
    // if (data?.bizCreditLastAPIDate) setBusinessCreditLastDate(data.bizCreditLastAPIDate)
    if (data?.bizCreditScore) setBusinessCreditScore(parseInt(data.bizCreditScore))
    if (data?.bizCreditScoreExpiryDate) setBusinessCreditScoreExpiry(data.bizCreditScoreExpiryDate)
    if (data?.bizCreditScoreState) setBusinessCreditScoreState(data.bizCreditScoreState)
    if (data?.bizCreditScoreStatus) setScoreStatus(data.bizCreditScoreStatus)
    setLoading(true)
  }

  return (
    <>
      <Box
        sx={{
          textAlign: 'left',
        }}
      >
        <SectionTitle title="Business Health Metrics" />
      </Box>

      <ProfileCardContainer>
        <BusinessSummary>
          <Box
            sx={{
              textAlign: 'left',
            }}
          >
            <Box sx={{ marginBottom: '22px' }}>
              <Typography component="div" variant="body1" color="primary" marginTop={3}>
                Business Credit Risk Score <sup style={{ left: '-0.3em' }}>TM</sup>
                <ToolTip content={<RiskScoreTooltipContent />} />
                &nbsp;
                <br />
                <Box sx={{ marginTop: '13px' }}>
                  <Typography
                    component="span"
                    variant="h5"
                    fontSize={business_info?.claimed_business_details?.crs ? '34px' : '20px'}
                    sx={{
                      color: theme.palette.color.blueLight,
                    }}
                  >
                    {business_info?.claimed_business_details?.crs || MOCK_DATA_BUSINESS.credit_risk_score}
                  </Typography>
                  {business_info?.claimed_business_details?.crs ? (
                    <Typography component="span">
                      &nbsp;of&nbsp;{credit_risk_score_max || MOCK_DATA_BUSINESS.credit_risk_score_max}
                    </Typography>
                  ) : (
                    ''
                  )}
                  &nbsp;
                </Box>
              </Typography>
            </Box>
            <Divider
              variant="left"
              sx={{
                borderWidth: '1px',
                Color: '#CEE4F5',
                width: '240px',
                marginBottom: '20px',
              }}
            />
            <Box sx={{ marginBottom: '40px' }}>
              <Typography component="div" variant="body1" color="primary">
                Business Credit Risk Class <sup style={{ left: '-0.3em' }}>TM</sup>
                <ToolTip content={<RiskClassTooltipContent />} />
                &nbsp;
                <br />
                <Box marginTop={2}>
                  <Typography
                    component="span"
                    variant="h5"
                    fontSize={business_info?.claimed_business_details?.crc ? '34px' : '20px'}
                    sx={{ color: colors }}
                  >
                    {business_info?.claimed_business_details?.crc || MOCK_DATA_BUSINESS.credit_class}
                  </Typography>
                  &nbsp;
                </Box>
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              textAlign: 'left',
            }}
          >
            <Box sx={{ marginRight: '15px' }}>
              <Typography component="div" sx={{ fontSize: '16px' }} color="primary">
                Business Credit Score&nbsp;
                <ToolTip component="span" content={<BusinessCreditTooltip />} />
              </Typography>

              {!!loading && <ThreeDotsLoadingSpinner width="30px" />}
              <Box>
                {!loading && user.accountType === 'free' ? (
                  <Link onClick={goToWelcome} target="_blank" underline="hover">
                    <Typography
                      component="span"
                      variant="button3"
                      color="secondary"
                      sx={{ cursor: 'pointer', fontSize: '12px' }}
                    >
                      Become a premium member <br />
                      to see your score!
                    </Typography>
                  </Link>
                ) : (
                  <div>
                    {/* getting gerdit score */}

                    {scoreStatus === 'SUCCESS' && businessCreditScoreSate !== 'E' && (
                      <Typography component="span" color="secondary" sx={{ fontSize: '12px', color: '#66668F' }}>
                        Valid through {moment(businessCreditScoreExpiry).format('MM/DD/YYYY')}
                      </Typography>
                    )}

                    {/* score expired status */}

                    {businessCreditScoreSate === 'E' && (
                      <div>
                        <Typography component="span" color="secondary" sx={{ fontSize: '12px', color: '#66668F' }}>
                          Score expired. &nbsp;
                        </Typography>
                        <Link onClick={getCreditScore} target="_blank" underline="hover">
                          <Typography
                            component="span"
                            variant="button3"
                            color="secondary"
                            sx={{ cursor: 'pointer', fontSize: '12px' }}
                          >
                            Click here to update
                          </Typography>
                        </Link>{' '}
                        <br />
                      </div>
                    )}

                    {!loading && scoreStatus === 'IA' && (
                      <div>
                        <Link onClick={getCreditScore} target="_blank" underline="hover">
                          <Typography
                            component="span"
                            variant="button3"
                            color="secondary"
                            sx={{ cursor: 'pointer', fontSize: '12px' }}
                          >
                            Click to see your score
                          </Typography>
                        </Link>{' '}
                      </div>
                    )}

                    {!loading && scoreStatus === 'NF' && (
                      <div>
                        <Typography color="#0099FF" variant='h6' marginTop='10px'>
                          Unavailable
                        </Typography>
                      </div>
                    )}

                    {scoreStatus === 'ER' && (
                      <div>
                        <Typography component="span" color="secondary" sx={{ fontSize: '12px', color: 'red' }}>
                          Unable to process, please try again.
                        </Typography>
                      </div>
                    )}
                  </div>
                )}
              </Box>
              <Box>
                <ProfileCompletedProgress>
                  {businessCreditScore && scoreStatus === 'SUCCESS' && businessCreditScoreSate !== 'E' ? (
                    <BusinessCreditProgress value={businessCreditScore} size="normal" sx={{ marginTop: '15px' }} />
                  ) : businessCreditScore && businessCreditScoreSate === 'E' ? (
                    <BusinessCreditProgressDisabled
                      value={businessCreditScore}
                      size="normal"
                      sx={{ marginTop: '15px' }}
                    />
                  ) : scoreStatus === 'NF' ? (
                    <div> </div>
                  ) : (
                    <BusinessCreditChart size="normal" sx={{ marginTop: '15px' }} />
                  )}
                </ProfileCompletedProgress>
              </Box>
            </Box>
          </Box>
        </BusinessSummary>
      </ProfileCardContainer>
    </>
  )
}

export default ClaimedBusinessProfile
